var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    enableBackground: "new 0 0 120 120",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#449FDB",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.695,118.611c-30.751,0-54.843-25.323-54.843-57.647c0-1.388,1.112-2.5,2.5-2.5h14.804 c1.384,0,2.5,1.112,2.5,2.5c0,28.624,18.1,38.824,35.04,38.824c17.656,0,33.141-15.62,33.141-33.988 c0-17.256-16.236-31.336-35.444-31.336H40.264v9.104c0,0.912,0.512,1.74-0.28,2.184c-0.788,0.44-1.252,0.416-2.028-0.052 L5.432,25.592c-0.748-0.456-1.076-1.268-1.068-2.144c0-0.88,0.532-1.684,1.272-2.132L38.444,1.74 c0.772-0.46,0.756-0.472,1.532-0.028c0.784,0.44,0.284,1.272,0.284,2.176v10.58h20.128c29.948,0,55.244,23.648,55.244,52.24 C115.641,95.6,91.893,118.611,62.695,118.611z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.571be4f0c5948acbe3fcd709e534416e.svg";
export { ForwardRef as ReactComponent };